/* eslint-disable react/style-prop-object */
import { useContext, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { popupcontext } from "../../../../context/Popupscontext";
import { useGetSpecificPermissionQuery } from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import Popup from "../../../Helpers/Popup/Popup";
import Loader from "../../../Helpers/Loader/Loader";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import PermissionsInf from "./PermissionsInf";

export function PermissionsPopup({ permissionId }) {
	let { setcurrentPermissionId, edited } = useContext(popupcontext);
	let { data, isLoading, refetch } = useGetSpecificPermissionQuery(
		permissionId,
		{
			skip: !permissionId,
		}
	);
	console.log("DATA Permission", data);
	const closeuser = () => {
		setcurrentPermissionId(null);
	};
	useEffect(() => {
		if (edited) {
			refetch();
		}
	}, [edited, refetch]);

	return (
		<Popup show={!!permissionId}>
			{isLoading && (
				<div className="loader-container">
					<Loader />
				</div>
			)}
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle={`${data?.data?.name}`} />
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={closeuser}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable">
				<PermissionsInf values={data?.data} />
			</Modal.Body>
		</Popup>
	);
}
